import { AddressState } from './address-state-model'

// https://www.iban.com/country-codes
export namespace AddressStateBrazil {
  export class Enum extends AddressState {
    static readonly AC = new Enum(12, 'AC', 'Acre')
    static readonly AL = new Enum(27, 'AL', 'Alagoas')
    static readonly AM = new Enum(13, 'AM', 'Amazonas')
    static readonly AP = new Enum(16, 'AP', 'Amapá')
    static readonly BA = new Enum(29, 'BA', 'Bahia')
    static readonly CE = new Enum(23, 'CE', 'Ceará')
    static readonly DF = new Enum(53, 'DF', 'Distrito Federal')
    static readonly ES = new Enum(32, 'ES', 'Espírito Santo')
    static readonly GO = new Enum(52, 'GO', 'Goiás')
    static readonly MA = new Enum(21, 'MA', 'Maranhão')
    static readonly MG = new Enum(31, 'MG', 'Minas Gerais')
    static readonly MS = new Enum(50, 'MS', 'Mato Grosso do Sul')
    static readonly MT = new Enum(51, 'MT', 'Mato Grosso')
    static readonly PA = new Enum(15, 'PA', 'Pará')
    static readonly PB = new Enum(25, 'PB', 'Paraíba')
    static readonly PE = new Enum(26, 'PE', 'Pernambuco')
    static readonly PI = new Enum(22, 'PI', 'Piauí')
    static readonly PR = new Enum(41, 'PR', 'Paraná')
    static readonly RJ = new Enum(33, 'RJ', 'Rio de Janeiro')
    static readonly RN = new Enum(24, 'RN', 'Rio Grande do Norte')
    static readonly RO = new Enum(11, 'RO', 'Rondônia')
    static readonly RR = new Enum(14, 'RR', 'Roraima')
    static readonly RS = new Enum(43, 'RS', 'Rio Grande do Sul')
    static readonly SC = new Enum(42, 'SC', 'Santa Catarina')
    static readonly SE = new Enum(28, 'SE', 'Sergipe')
    static readonly SP = new Enum(35, 'SP', 'São Paulo')
    static readonly TO = new Enum(17, 'TO', 'Tocantins')

    private constructor(
      public readonly id: number,
      public readonly name: string,
      public readonly title: string
    ) {
      super(id, name, title)
    }
  }

  export const getByValue = (value: string | undefined): Enum | undefined => {
    if (!value) return
    return Object.values(AddressStateBrazil.Enum).find(
      state => state.name === value || state.title === value
    )
  }

  export const values = (): Enum[] => {
    return Object.values(AddressStateBrazil.Enum)
  }
}
